/* eslint-disable import/no-cycle */
import {computed, decorate, observable} from 'mobx';
import {Api} from '../middleware/api';
import {EntityStore} from './entityStore';
import {Sensor} from '../models/sensor';
import {sortAlphabetically} from '../components/shared/tables/sorters';

export class SensorStore extends EntityStore {
  sensors = [];
  identityField = 'name';

  constructor(rootStore) {
    super(rootStore, 'sensors', Api.sensors, Sensor);
  }

  getByHierarchyIdAndSensorType(hierarchyId, sensorType) {
    return this.sensors
      .filter((s) => s.hierarchyId === hierarchyId && s.sensorType === sensorType)
      .sort((a, b) => sortAlphabetically(a.label, b.label));
  }

  get manualSensors() {
    return this.sensors.filter((s) => s.isManual);
  }
}

decorate(SensorStore, {
  sensors: observable,
  manualSensors: computed,
});
